import type { ButtonHTMLAttributes, ReactNode, Ref } from "react";
import { buttonClasses, type ButtonSize, type ButtonVariant } from "./buttonClasses";

interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** React 19 accepts `ref` as a regular prop on function components; the spread forwards it. */
  ref?: Ref<HTMLButtonElement> | undefined;
  children: ReactNode;
}

export function Button({
  variant = "primary",
  size = "md",
  className,
  ...rest
}: ButtonProps): ReactNode {
  return <button type="button" {...rest} className={buttonClasses(variant, size, className)} />;
}
